import React, { PureComponent } from 'react'
import { Layout, Button, message, Menu } from 'antd'
import firebase from 'firebase'
import firebaseui from 'firebaseui'
import _ from 'lodash';

import 'firebaseui/dist/firebaseui.css'
import './style.css'

import Dashboard from './components/dashboard/index'
import Login from './components/Login'
import Projects from './components/project/index'

import { store } from './store'
import { addProject } from './actions/projects';
import { addUser, addFirebaseToken, removeFirebaseToken } from './actions/user';
import { reactLocalStorage } from 'reactjs-localstorage';

import config from './config'
import nanoid from 'nanoid'

const { Header, Content, Sider } = Layout

// Google OAuth Client ID, needed to support One-tap sign-up.
// Set to null if One-tap sign-up is not supported.
const CLIENT_ID = null

class App extends PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      user: null,
      collapse: true,
      isProjectLoading: true,
      onExistingProjectSelected: null,
      isSiderClosed: false
    }
  }

  componentDidMount () {
    if (!firebase.apps.length) {
      firebase.initializeApp(config)

      // Initialize the FirebaseUI Widget using Firebase.
      const ui = (this.ui = new firebaseui.auth.AuthUI(firebase.auth()))
      // Disable auto-sign in.
      ui.disableAutoSignIn()

      // Listen to change in auth state so it displays the correct UI for when
      // the user is signed in or not.
      firebase.auth().onAuthStateChanged(user => {
        this.setState({ user })
        document.getElementById('loading').style.display = 'none'
        document.getElementById('loaded').style.display = 'block'
        if (user) {
          this.handleSignedInUser(user)
          user.getIdToken().then(function(data) {
            store.dispatch(addFirebaseToken(data))

          });
        }else this.handleSignedOutUser()
      })
    }
  }

  getUiConfig () {
    return {
      callbacks: {
        // Called when the user has been successfully signed in.
        signInSuccess: function (user, credential, redirectUrl) {
          // console.log('credential: ' + JSON.stringify(credential))
          // console.log('user: ' + JSON.stringify(user))

          this.handleSignedInUser(user)
          message.success('Login successfully!');
          // Do not redirect.
          return false
        }
      },
      // Opens IDP Providers sign-in flow in a popup.
      signInFlow: 'popup',
      signInOptions: [
        // TODO(developer): Remove the providers you don't need for your app.
        {
          provider: firebase.auth.GoogleAuthProvider.PROVIDER_ID,
          customParameters: { 'hd': 'vase.ai' },
          // Required to enable this provider in One-Tap Sign-up.
          authMethod: 'https://accounts.google.com',
          // Required to enable ID token credentials for this provider.
          clientId: CLIENT_ID
        }
      ],
      // Terms of service url.
      tosUrl: 'https://www.google.com',
      credentialHelper: CLIENT_ID && CLIENT_ID !== 'YOUR_OAUTH_CLIENT_ID'
        ? firebaseui.auth.CredentialHelper.GOOGLE_YOLO
        : firebaseui.auth.CredentialHelper.ACCOUNT_CHOOSER_COM
    }
  }

  onCollapse = (collapse) => {
    // console.log(collapse);
    setTimeout(() => { 
      if(collapse === true){
        this.setState({
          isSiderClosed: true
        })
      }
      this.setState({ 
        collapse
      }); 
    },0)
  }

  handleSignedInUser (user) {
    if(user.email.includes('vase.ai') === false){
      message.error('Failed to authenticate. Suspicious email is not allow.')
      this.signOut()
    }else{
      var user = { uid: user.uid, displayName: user.displayName, email: user.email };
      reactLocalStorage.setObject('user', user);
      this.updateUser();
    }
  }

  loadProjectData() {
    /* Get Projects From User */
    var projectQuestionsRef = firebase
          .database()
          .ref(config.firebaseProjectsPath);

    projectQuestionsRef
      
      .orderByChild('userId').equalTo(store.getState().user.uid)
      .once("value", (snapshot) => {
        var projectsFound = snapshot.val()
        if(projectsFound){
          var projectArr = _.values(projectsFound);
          let projects = store.getState().projects;

          if(projects.length === 0) {
            _.orderBy(projectArr,['timestamp'],['asc']).forEach((sp, ind) => {
              store.dispatch(addProject(sp))
            })
          } else {
          }
        }
    });
  }

  updateUser (){
    var user = reactLocalStorage.getObject('user')
    // console.log('firebase user auth: ', JSON.stringify(user))
    store.dispatch(addUser(user))

    setTimeout(() => {
      this.loadProjectData()
    },0)
  }

  handleSignedOutUser () {
    this.ui.start('#firebaseui-container', this.getUiConfig())
  }

  signOut () {
    firebase.auth().signOut()
    store.dispatch(removeFirebaseToken());
  }

  handleExistingProjectSelected (item) {
    // console.log('handleExistingProjectSelected: ', item)
    this.setState({
      onExistingProjectSelected: item
    })
  }


  render () {
    const { user, collapse, isProjectLoading, onExistingProjectSelected,isSiderClosed, projectData } = this.state
    // console.log('App.js rendering...')
    return (
      <div style={{ textAlign: 'center' }}>
        <Layout style={{ height: '100%' }}>      
          <Layout>
            <Header style={{ background: '#4BAD00' }}>
              <div className='logo'>
                Vase QSF
              </div>
              {user && (
              <div className='account'>
                <div id='user-info'>
                  <div id='name'>
                    {user.displayName}
                  </div>
                  <div id='email'>
                    {user.email}
                  </div>
                  <Button id='sign-out' onClick={this.signOut}>
                    Sign Out
                  </Button>
                </div>
              </div>
              )}
            </Header>
            <Content style={{ background: '#fff', padding: 20 }}>
              <div id='loading'>
                Loading...
              </div>
              <div id='loaded' className='hidden'>
                {user ? (
                  <div id='user-signed-in' className=''>
                    <Dashboard
                      isSiderClosed={isSiderClosed}
                      onExistingProjectSelected={onExistingProjectSelected}
                    />
                  </div>
                  ) : (
                  <div id='user-signed-out' className=''>
                    <div>
                      <h4>You are signed out.</h4>
                      <div id='firebaseui-spa'>
                        <div id='firebaseui-container' />
                      </div>
                    </div>
                  </div>
                  )}
              </div>
              
            </Content>
          </Layout>

          {
            (user) &&
            (
              <Sider
                style={{ background: 'rgba(75, 173, 0, 0.25)' }}    
                collapsible
                collapsed={collapse}
                onCollapse={this.onCollapse}>
                {
                  (!collapse) && 
                  (
                    <Projects
                      handleExistingProjectSelected={this.handleExistingProjectSelected.bind(this)}
                    ></Projects>
                  )
                  
                }
              </Sider>
            )
          }
          
        </Layout>
        
      </div>
    )
  }
}


export default App;

// export default App



// WEBPACK FOOTER //
// ./src/App.js